const getApiDocsUrl = () => {
  const hostname = window.location.hostname;

  // Production - Turning Pages
  if (hostname.includes('turningpages.co.uk')) {
    return 'https://api.turningpages.co.uk/api/external/v1/docs';
  }

  // Production - Count Me In Digital
  if (hostname.includes('countmeindigital.co.uk')) {
    return 'https://api.countmeindigital.co.uk/api/external/v1/docs';
  }

  // Staging
  if (hostname.includes('st-staging.co.uk')) {
    return 'https://api.st-staging.co.uk/api/external/v1/docs';
  }

  // Default fallback - use current origin
  return `${window.location.origin}/api/external/v1/docs`;
};

export default getApiDocsUrl;
